import { render } from "./limits.vue?vue&type=template&id=27e4348e&scoped=true&ts=true"
import script from "./limits.vue?vue&type=script&lang=ts"
export * from "./limits.vue?vue&type=script&lang=ts"

import "./limits.vue?vue&type=style&index=0&id=27e4348e&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e4348e"]])

export default __exports__